<template>
  <button class="button"
          :class="{['button--' + modifier]: modifier, 'button--full-width': fullWidth, 'button--disabled': disabled, 'button--short': short}"
          :name="name"
          :id="id"
          :type="type"
          :data-cy="cypressName"
          :disabled="disabled">
    <span class="vf-icon"
          :class="{[icon]: !!icon, 'vf-icon-upload': uploadIcon}"
          :aria-label="iconAltText"
          role="img"
          v-if="icon || uploadIcon">
    </span>
    <span v-html="label"></span>
  </button>
</template>
<script>
export default {
  name: 'CsoButton',
  props: {
    icon: {
      type: String,
      required: false,
      default: ''
    },
    iconAltText: {
      type: String,
      required: false,
      default: ''
    },
    modifier: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    id: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    fullWidth: {
      type: Boolean,
      required: false
    },
    short: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    uploadIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    cypressName: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss">
.button {
  @include hidden-print();
  display: inline-block;
  font-family: $font-family-regular;
  font-size: 16px;
  line-height: 42px;
  min-height: 42px;
  padding: 0 24px;
  text-align: center;
  cursor: pointer;
  border-radius: 100px;
  min-width: 188px;
  outline: none;
  text-decoration: none;
  background-color: $yellow;
  border: 1px solid $yellow;
  color: $black;

  &:active {
    background-color: $yellow-dark;
    border-color: $yellow-dark;
  }

  &:hover {
    background-color: $yellow-pale;
    border-color: $yellow-pale;
  }

  &:focus {
    outline: 2px solid $blue;
    outline-offset: 4px;
  }

  &--disabled {
    background-color: $gray-f2;
    border-color: $gray-f2;
    color: $gray-4d;

    &:hover {
      cursor: not-allowed;
      background-color: $gray-f2;
      border-color: $gray-f2;
    }
  }

  &--full-width {
    width: 100%;
  }

  &--short {
    min-width: unset;
  }

  &--light-white {
    background-color: rgba(0,0,0,0);
    border: 1px solid $black;
    color: $black;

    &.button--disabled[disabled] {
      background-color: $gray-f2;
      border: 1px solid $gray-f2;
      color: $gray-dark;
    }

    &:active,
    &.active {
      background-color: $gray-darker;
      border-color: $gray-darker;
      color: $white;
    }

    &:hover {
      background-color: $black;
      border-color: $black;
      color: $white;
    }
  }

  &--link-blue {
    border: none;
    background-color: transparent;
    color: $blue-16;
    text-decoration: underline;
    padding: 4px 25px;
    border-radius: 0;
    font-size: 16px;
    line-height: 20px;
    min-height: 0;

    &[disabled] {
      background: none;
      border: none;
      color: $gray-light;
      cursor: not-allowed;
    }

    &:focus {
      outline: 2px solid $blue;
    }

    &:hover,
    &:active {
      color: $blue-1d;
      background: none;
    }
  }


  .vf-icon {
    font-size: 20px;
    position: relative;
    top: 5px;
    left: -5px;
  }

  .vf-icon-upload {
    top: 5px;
    position: relative;
    display: inline-block;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 0;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    background-image: url('/static/icons/arrow-up.svg');
  }

  &:not([disabled]):hover .vf-icon-upload {
    filter: invert(100%);
  }
}
</style>
